//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Steps',
  props: {
    activeStep: { type: Number, default: 0 },
    isCertificateSuccess: { type: Boolean, default: true },
  },
};
